import { GeolocalizationProvider } from "providers/geolocalization/geolocalization";
import { DomainStorageProvider } from "providers/domain-storage/domain-storage";
import { RemoteServicesProvider } from "providers/remote-services/remote-services";
import { LoginProvider } from "providers/login/login";
import { Component, Input, ViewChild, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NgForm } from "@angular/forms";
import { Router } from "@angular/router";
import { AppService } from "app/app.service";


@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
  })
  export class ForgotPasswordComponent implements OnInit {
    @ViewChild("loginForm") loginForm: NgForm;
    
    data = {
        email: ''
    }

    loadingComponent: any = null;
    isLoading: boolean = false;
    error: any = null;
    success: boolean = false;
    redirect: string  = null;

    constructor(
        private appService: AppService,
        private router: Router,
        public loginProvider: LoginProvider,
        private translate: TranslateService,
        public remoteServicesProvider: RemoteServicesProvider,
        public domainStorageProvider: DomainStorageProvider,
        public geolocalizationProvider: GeolocalizationProvider
    ) {
        this.showHideMenu(false);
    }

    ngOnInit() {
  
    }

    ngOnDestroy() {
        this.showHideMenu(true);
    }

    showHideMenu(show) {
        this.appService.onMainMenuEvent.emit(show);
    }

    back() {
        this.router.navigate(["/"]);
    }
    
    async submit() {
        this.isLoading = true;
        this.error = null;
        this.redirect = null;
        this.success = false;
        try{
            await this.remoteServicesProvider.sendForgotPasswordRequest(this.data);
          
            this.success = true;
            this.clearForm();
        }
        catch(e){
            if(e && e.status == 400){
                this.error = this.translate.instant("ForgotPasswordPage.ErrorMessage");
            }
            else{
                this.error = this.translate.instant("App.UnexpectedError");
            }
        }
        
        this.isLoading = false;
    }

    clearForm() {
        if (this.loginForm)
            this.loginForm.reset();
    }
}
